var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"pt-12"},[(!_vm.isAdmin)?_c('v-layout',[_c('agent-layout',{attrs:{"refs":"layout"}})],1):_c('v-layout',[_c('admin-layout',{attrs:{"refs":"layout"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }